module.exports = {
  message: {
    select_region: "选择大区",
    europe: "欧洲",
    america: "美洲",
    region_tip: "请注意，各大区角色信息不互通",
    confirm_select: "确认选择",
    navigator_website: "官网",
    navigator_collect: "收藏",
    navigator_service: "客服",
    navigator_teach: "使用教程",
    navigator_logout: "登出",
    navigator_mobile_logout: "手机号登录",
    navigator_email_logout: "邮箱登录",
    navigator_download: "下载",
    navigator_signIn: "注册",
    navigator_lang: "登录",
    navigator_email: "邮箱",
    input_account: "请输入账号",
    input_mobile: "请输入手机号码",
    input_password: "请输入密码",
    input_password_again: "请再次输入密码",
    input_email_address: "请输入邮箱账号",
    input_reset_email: "请输入需要重置密码的账号或邮箱     ",
    input_reset_password: "，请通过以下方式验证后重新设置密码 ",
    retrieve_password: "找回密码",
    forget_password: "忘记密码",
    next_step: "下一步",
    bind_email: "绑定邮箱",
    input_bind_email: "请输入绑定邮箱账号",
    bound_email: "已绑定邮箱",
    enter_code: "请输入验证码",
    get_code: " 读取验证码 ",
    get_code_seconds: "s",
    security_verification: "安全验证",
    inputTheAnswer: "请输入图中验证码",
    noneSelectArea: "请选择手机号码所在区号",
    confirm: "确定",
    bind: "绑定",
    agree: "阅读并同意",
    tips_1: "未注册的手机号码沿着后将自动注册并登录",
    copy_success: "复制成功！",
    copy_fail: "请手动复制",
    incorrect_email: "请输入正确的邮箱格式！",
    emailTips1: "密码不能包含空格或者中文字符！",
    emailTips2: "请输入至少6位密码",
    emailTips3: "两次密码不相等",
    emailTips4: "验证码错误",
    emailTips5: "请输入4-12位以字母和数字组合的账号名",
    emailTips6: "请输入6~20位字母数字非中文特殊字符组合的密码",
    emailTips7: "两次密码不一致",
    selectAreaCode: "选择区号",
    urlError: "当前访问地址错误！",
    ThreeTips: "温馨提示",
    verifiedTips1: "您必须年满18岁才能登录此游戏",
    verifiedTips2: "登录失败，需完成实名认证后可体验游戏",
    rules_clause: "用户协议",
    privacy_clause: "隐私条款",
    service_email: "客服邮箱：",
    infoTitle: "PC端登录及储值教程",
    EmailAddress: "maplestoryr.na@gmail.com",
    selectAgeRange: "请选择年龄范围。",
    payFailed: "储值失败",
    payFailedMessage: "超过当月充值金额上限，无法进行充值",
    ageConfirm: "年龄确认",
    limitTip: "每个月储值上限会根据年龄范围进行 限制，如需变更请到客服中心提问",
    age13: "小于等于13岁/禁止储值",
    age14_17: "13岁~18岁/每月限制充值138美元",
    age18: "18岁以上/充值无任何限制",
  },
};
